import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { ProgramWiseModuleSettingsRoute } from "./routes";

export default store => ({
  path: "module-settings",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "schoolSettings" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [ProgramWiseModuleSettingsRoute(store)],
});
